import styles from "./media-formats-input-modal.module.scss";

import React from "react";
import CreateButton from "@/components/common/create-button";
import { useCreateProcessInputsHandler } from "@/hooks/ai-tool-process/use-create-process-inputs-handler";
import MediaFormatsInput, {
  MediaFormatsInputProps,
} from "@/components/common/input/media-formats-input";
import MediaInputProvider from "@/providers/media-input-provider/media-input-provider";
import { MediaInputStorage } from "@/services/storage/base/media-input-storage";
import {
  DatasetDurationManager,
  DatasetSizeManager,
} from "@/services/license/base/license-manager-abstractions";
import WavesurferProvider from "@/hooks/providers/wavesurfer-provider";

export interface MediaFormatsInputModalPropsBase
  extends MediaFormatsInputProps {
  onClick: (file: File | null) => void;
  sessionStorage: MediaInputStorage;
  licenseManager: DatasetSizeManager & DatasetDurationManager;
}

export interface MediaFormatsInputModalProps
  extends MediaFormatsInputModalPropsBase {
  children?: React.ReactNode;
}

const MediaFormatsInputModal = (props: MediaFormatsInputModalProps) => {
  return (
    <MediaInputProvider
      sessionStorage={props.sessionStorage}
      licenseManager={props.licenseManager}
    >
      <MediaFormatsInputModalContent {...props} />
    </MediaInputProvider>
  );
};

const MediaFormatsInputModalContent = (props: MediaFormatsInputModalProps) => {
  const { isLoading, isActive, songFile } = useCreateProcessInputsHandler();

  return (
    <WavesurferProvider>
      <div className={styles.modal}>
        <MediaFormatsInput {...props} />
        {props.children}
        <CreateButton
          isActive={isActive}
          isLoading={isLoading}
          onClick={() => props.onClick(songFile)}
        />
      </div>
    </WavesurferProvider>
  );
};

export default MediaFormatsInputModal;
